import React from "react";
import Header from "./Header";
import Request from "./Request";
import About2 from "./About2";

const Home = () => {
  return (
    <div className="home-container bg-white text-gray-800">
      {/* Hero Section */}
      <Header />

      {/* About Section */}
      <div className="my-24 px-4 md:px-10">
        <About2 />
      </div>

      {/* Request Section */}
      <div className="mb-16 px-4 md:px-10">
        <Request />
      </div>
    </div>
  );
};

export default Home;
